var React = require('react');

function ArrowUpRightSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M66.6,140l0-31.4c0-13.3,10.7-24,24-24l274.9-0.1c13.3,0,24,10.7,24,24v274.9c0,13.3-10.7,24-24,24H334\n\tc-13.4,0-24.3-11.1-24-24.5c0.1-54.3,0.3-108.5,0.4-162.8c-66.5,66.5-133.1,133.1-199.6,199.6c-9.4,9.4-24.5,9.4-33.9,0l-22.6-22.6\n\tc-9.4-9.4-9.4-24.5,0-33.9c66.4-66.4,132.7-132.7,199.1-199.1c-54.1,0-108.1-0.1-162.2-0.1C77.6,164.3,66.5,153.5,66.6,140z"}));
}

ArrowUpRightSolid.defaultProps = {"version":"1.1","id":"Layer_1","focusable":"false","x":"0px","y":"0px","viewBox":"0 0 448 512","style":{"enableBackground":"new 0 0 448 512"},"xmlSpace":"preserve"};

module.exports = ArrowUpRightSolid;

ArrowUpRightSolid.default = ArrowUpRightSolid;
